//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'

export default {
  name: 'order',
  components: {
      cmBlank,cmLoadmore
  },
  data () {
    return {
        title:'全部订单',
      blankShow:false,
      loadStatus:false,
      loadmoreText:'正在加载。。。',
      busy:false,
      pageFlag:2,
      hasNext:0,
      lastId:0,
      status:0,
      list:[],
    }
  },
  created(){
    this.status = Number(this.$route.params.status);
  },
  amount(){
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    search(){
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.getList();
    },
    getList(){
        this.$api.orderList({last_id:this.lastId,page_flag:this.pageFlag,status:this.status}).then((res)=>{
          if(res){
            // console.log(res);
            if(!this.lastId){
                this.blankShow = res.data.length > 0 ? false : true;
            }
            this.hasNext = res.hasNext;
            this.lastId = res.lastId;
            res.data.forEach((item)=>{
                this.list.push(item);
            });
          }
        })  
    },
    deatil(id){
        this.$router.push({name:'deatil',params:{id:id}})
    },
    loadmore(){
        if(this.lastId > 0 && !this.hasNext){
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '没有更多了。。。'
            return ;
        }
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '正在加载。。。';
        // console.log(1111);
        this.getList();
        setTimeout(()=>{
           if(this.blankShow){
                this.busy = true;
                this.loadStatus = false;
                this.loadmoreText = '没有更多了。。。'
            }else{
                if(this.hasNext > 0){
                    this.loadStatus = false;
                    this.busy = false;
                }else{
                    this.busy = true;
                    this.loadStatus = true;
                    this.loadmoreText = '没有更多了。。。'
                }
            }
        },1500)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/order.vue